<template>
  <div class="app-container">
    <vxe-toolbar>
      <template #buttons>
        <vxe-button icon="vxe-icon-square-plus" @click="insertEvent()">新增</vxe-button>
        <vxe-button @click="removeEvent">删除选中</vxe-button>
        <vxe-button @click="getSelectionEvent">获取选中</vxe-button>
        <vxe-button icon="vxe-icon-save" @click="getInsertEvent">获取新增</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table border show-overflow ref="xTable" height="500" :data="tableData" @checkbox-change="selectChange" @checkbox-all="selectChangeAll" :checkbox-config="{ range: true }"
      :mouse-config="{ selected: true }" :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true, isChecked: true }"
      :edit-config="{ trigger: 'dblclick', mode: 'cell' }">
      <vxe-column type="seq" width="60"></vxe-column>
      <vxe-column type="checkbox" width="60"></vxe-column>
      <vxe-column field="name" title="Name" :edit-render="{ autofocus: '.myinput' }">
        <template #edit="{ row }">
          <input v-model="row.name" type="text" class="myinput" />
        </template>
      </vxe-column>
      <vxe-column field="role" title="Role" :edit-render="{ autofocus: '.vxe-input--inner' }">
        <template #edit="{ row }">
          <vxe-input v-model="row.role" type="text"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="nickname" title="Nickname" :edit-render="{ autofocus: '.vxe-input--inner' }">
        <template #edit="{ row }">
          <vxe-input v-model="row.nickname" type="text"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="address" title="Address" :edit-render="{ autofocus: '.vxe-input--inner' }">
        <template #edit="{ row }">
          <vxe-input v-model="row.address" type="text"></vxe-input>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>
<script>
import optionMixins from "@/mixins/option";
import VXETable from "vxe-table"
import productSelect from "@/components/business/sales/select";
export default {
  name: "keyboardtable",
  mixins: [optionMixins],
  components: { productSelect },
  data() {
    return {
      api: require("@/api/stock/inventoryPeriodBeginning").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      productApi: require("@/api/ba/product").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      propertyApi: require("@/api/ba/property").default,
      tradeUnitList: [],
      warehouseList: [],
      params: {
        WarehouseId: 11,
        WarehouseNo: "CK06",
        WarehouseName: "成品仓",
        InDate: null,
      },
      user: {
        EmpId: null,
        EmpName: "",
      },
      rows: [],
      delRows: [],
      listTotal: 0,
      initTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      products: [],
      initProducts: [],
      propertys: [],
      tableData: [
        { id: 10001, name: 'Test1', role: 'Develop', sex: 'Man', age: 28, address: 'test abc' },
        { id: 10002, name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou' },
        { id: 10003, name: 'Test3', role: 'PM', sex: 'Man', age: 32, address: 'Shanghai' },
        { id: 10004, name: 'Test4', role: 'Designer', sex: 'Women', age: 23, address: 'test abc' },
        { id: 10005, name: 'Test5', role: 'Develop', sex: 'Women', age: 30, address: 'Shanghai' },
        { id: 10006, name: 'Test6', role: 'Designer', sex: 'Women', age: 21, address: 'test abc' },
        { id: 10007, name: 'Test7', role: 'Test', sex: 'Man', age: 29, address: 'test abc' },
        { id: 10008, name: 'Test8', role: 'Develop', sex: 'Man', age: 35, address: 'test abc' }
      ],
      tableMenu: {
        body: {
          options: [
            [
              { code: 'copy', name: '复制', prefixIcon: 'vxe-icon-copy', disabled: false },
              { code: 'remove', name: '删除', disabled: false },
              { code: 'save', name: '保存', prefixIcon: 'vxe-icon-save', disabled: false }
            ]
          ]
        }
      }
    }
  },
  mounted() {
    const user = this.$store.state.user;
    if (user) {
      this.user.EmpId = user.empId;
      this.user.EmpName = user.name;
    }
    this.getDataFunc({ pageIndex: 1, pageSize: 10 }).then(res => {
      if (res.Code == 0) {
        this.rows = res.Data;
      }
    });
    this.callOptionApi();
    this.tradeUnitApi.list({ TradeUnitTypes: [1, 2], Status: 1 }).then((res) => {
      if (res.Code == 0) this.tradeUnitList = res.Data;
    });
    this.productApi.list({ ...this.pageParams, Property: "销售", Status: 1, }).then((res) => {
      this.products = res.Data;
      this.initProducts = res.Data;
      this.listTotal = res.Count;
      this.initTotal = res.Count;
    });
    this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then((res) => {
      if (res.Code === 0) {
        this.warehouseList = res.Data;
      }
    });
    this.propertyApi.list({ Status: 1 }).then(res => {
      if (res.Code == 0) {
        this.propertys = res.Data;
      }
    })
  },
  methods: {
    selectChange({ checked, row }) {
      console.log("checked", checked)
      console.log("row", JSON.parse(JSON.stringify(row)))
    },
    selectChangeAll({ checked }) {
      console.log("checked", checked)
    },
    async insertEvent() {
      // const $table = this.$refs.xTable
      // const record = { id: 10009, name: 'Test9', role: 'Develop', sex: 'Man', age: 28, address: 'test abc99' };
      // const { row: newRow } = await $table.insertAt(record)
      // await $table.setActiveCell(newRow, 'name')
      // console.log("row",newRow)

      this.tableData.push(
        { id: 10009, name: 'Test9', role: 'Develop', sex: 'Man', age: 28, address: 'test abc99' }
      )
    },
    removeEvent() {
      const $table = this.$refs.xTable
      const selectRecords = $table.getCheckboxRecords()
      console.log("selectRecords", selectRecords)
      this.tableData.splice(1, 1);
    },
    getInsertEvent() {
      const $table = this.$refs.xTable
      const insertRecords = $table.getInsertRecords()
      console.log("insertRecords", insertRecords)
      // VXETable.modal.alert(insertRecords.length)
    },
    getSelectionEvent() {
      const $table = this.$refs.xTable
      const selectRecords = $table.getCheckboxRecords()
      console.log("selectRecords", selectRecords)
      // VXETable.modal.alert(selectRecords.length)
    },


    setEdit(row) {
      if (row.T !== 0) row.T = 1;
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(2));
    },
    changeTu(id, row) {
      this.setEdit(row);
      var tu = this.tradeUnitList.find(x => x.TradeUnitId == id);
      row.TradeUnitNo = tu.TradeUnitNo;
    },
    onInput(row, type) {
      this.setEdit(row);
      row[type] = parseFloat(Number(row[type]).toFixed(2));
    },
    changeWarehouse(val) {
      let item = this.warehouseList.find(x => x.WarehouseId == val);
      console.log("仓库", item);
      this.params.WarehouseNo = item.WarehouseNo;
      this.params.WarehouseName = item.WarehouseName;
    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      this.setEdit(row);

      row.Rate = data;
      row.Rate = Number(row.Rate).toFixed(2);
      if (row.IsMain) {
        row.Quantity2 = this.getQuantity(row.Quantity / Number(data));
      } else {
        row.Quantity = this.getQuantity(row.Quantity2 / Number(data));
      }
    },
    changeQuantity(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") return;
      this.setEdit(row);

      if (row.Units.length > 0) {
        if (row.IsMain) {
          row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate));
        } else {
          row.Quantity2 = this.getQuantity(data * Number(row.Rate));
        }
      } else {
        row.Quantity2 = row.Quantity;
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") return;
      this.setEdit(row);

      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(2);
        } else {
          console.log("数量1=数量2/换算率");
          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(2);
        } else {
          console.log("数量1=数量2*换算率");
          row.Quantity = this.getQuantity(data * row.Rate);
        }
      }
    },

    /*计量单位相关函数*/
    compareUnitId(data, row, index) {
      this.setEdit(row);

      let lastIsMain = row.IsMain;
      if (data.IsMain) {
        row.IsMain = false;
      } else {
        row.IsMain = true;
      }
      let findIndex = 0;
      if (row.Unit == row.Unit2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        if (row.IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, row.Units);
          this.changeLeftUnitId(row, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, row.Units);
          this.changeLeftUnitId(row, findIndex);
        }
      } else {
        if (row.IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, row.Units);
          this.changeLeftUnitId(row, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, row.Units);
          this.changeLeftUnitId(row, findIndex, data.Rate);
          if (!lastIsMain) {
            row.Quantity = row.Quantity2;
          }
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate));
        }
      }
      this.changeQuantity2(row.Quantity2, row, index, 1);
    },
    changeLeftUnitId(row, findIndex, Rate = 0) {
      row.Unit = row.Units[findIndex].UnitId;
      row.UnitName = row.Units[findIndex].UnitName;
      if (Rate > 0) {
        row.Rate = Rate;
      }
    },
    compareSaUnit(data, row, index) {
      this.setEdit(row)

      let lastIsMain = row.IsMain;
      row.IsMain = data.IsMain;
      let findIndex = 0;
      if (row.Unit == row.Unit2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, row.Units);
          this.changeRightUnitId(row, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, row.Units);
          this.changeRightUnitId(row, findIndex);
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, row.Units);
          this.changeRightUnitId(row, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, row.Units);
          this.changeRightUnitId(row, findIndex, data.Rate);
          if (lastIsMain) {
            row.Quantity2 = row.Quantity;
          }
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate));
        }
      }
      this.changeQuantity(row.Quantity, row, index, 1);
    },
    changeRightUnitId(row, findIndex, Rate = 0) {
      row.Unit2 = row.Units[findIndex].UnitId;
      row.UnitName2 = row.Units[findIndex].UnitName;
      if (Rate > 0) {
        row.Rate = Rate;
      }
    },
    /****************/

    /*存货选择框相关函数*/
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.products = this.initProducts;
      this.listTotal = this.initTotal;
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val;
      var params = { ...this.pageParams, Property: "销售", Status: 1, ProductName: text1 };
      this.productApi.list(params).then((res) => {
        if (res.Code == 0) {
          this.products = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text) {
      var params = { Property: "销售", pageIndex: 1, pageSize: 7, ProductName: text, Status: 1 };
      this.productApi.list(params).then((res) => {
        if (res.Code == 0) {
          this.products = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    // 选择存货名称
    onSelect(e, row, index) {
      console.log("e", JSON.parse(JSON.stringify(e)));

      this.setEdit(row);

      row.ColorId = null;
      row.PropertyId = null;

      row.UnitName = "";
      row.UnitName2 = "";
      row.ColorName = "";
      row.WarehouseId = this.params.WarehouseId;
      row.WarehouseNo = this.params.WarehouseNo;
      row.WarehouseName = this.params.WarehouseName;
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.UseBatchNumber = e.BatchNumber; //是否启用批号
      row.Colors = e.Colors;
      row.Units = e.Units;
      row.Unit = e.SkUnitId;
      row.ChangeType = 0;
      row.UnitType = 0;
      row.UseColor = e.UseColor;
      row.UseProcess = e.UseProcess;

      if (e.Units.length === 0) {
        row.Unit = e.SkUnitId;
        row.UnitName = e.SkUnitName;
      } else {
        row.UnitType = 1;
        e.Units.forEach((item) => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
        });
        if (row.Unit) {
          let index = this.getUnitIndex(3, e.Units, row.Unit);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;

          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = assistData.Rate.toFixed(5);
          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = data.Rate.toFixed(5);
          }
          row.Unit2 = assistData.UnitId;
          row.UnitName2 = assistData.UnitName;
        } else {
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.Unit = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.Unit2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = noMainData[0].Rate.toFixed(5);
          row.IsMain = true;
        }
      }
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    //获取计量单位的值
    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
    /******************/

    /*查询添加删除保存*/
    getDataFunc(params) {
      params = { ...params, ...this.params };
      params = this.$commonJs.obj.removeNullKey(params);
      return new Promise((resolve, reject) => {
        this.api.list(params).then(res => {
          res.Data = res.Data.map(x => {
            if (x.Units.length === 0 || x.Units == null) {
              x.UnitType = 0;
            } else {
              x.UnitType = 1;
              let unit = x.Units.find(v => x.Unit === v.UnitId);
              if (unit) x.IsMain = unit.IsMain;
              x.Units.forEach(v => {
                if (v.ChangeType == 1) x.ChangeType = v.ChangeType
              })
            }
            return { ...x, T: null }
          })
          resolve(res);
        })
      })
    },
    onAdd() {
      this.rows.push({
        Id: 0,
        InDate: null, //入库日期
        InNumber: "", //入库单号
        WarehouseId: this.params.WarehouseId, //仓库
        WarehouseNo: this.params.WarehouseNo,
        WarehouseName: this.params.WarehouseName,
        ProductId: null, //存货
        ProductName: "", //存货名称
        ProductNo: "", //存货编码
        ProductSpec: "", //规格型号
        PropertyId: null, //属性
        PropertyName: "",
        UseProcess: false, //启用属性
        ColorId: null, //颜色
        Colors: [],
        UseColor: false,
        BatchNumber: "", //批号
        UseBatchNumber: false,
        Unit: null, //单位
        UnitName: "",
        Unit2: null, //单位2
        UnitName2: "",
        Units: [],
        ChangeType: 0, //单位换算类型
        UnitType: 0, //0：单计量，1：多计量
        IsMain: false,
        Quantity: null, //数量
        Quantity2: null, //数量2
        BaseQuantity: null, //主数量
        SubQuantity: null, //辅数量
        BaseUnit: null, //主单位
        SubUnit: null, //辅单位
        Rate: null, //换算率
        TradeUnitId: null, //供应商
        TradeUnitName: null,
        TradeUnitNo: null,
        MakeEmpId: this.user.EmpId, //制单人
        MakeEmpName: this.user.EmpName,
        Amount: null, //金额
        Price: null, //单价
        Price2: null, //单价2
        BasePrice: null, //主单价
        SubPrice: null, //辅单价
        T: 0,
      });
    },
    /*********/
  }
}
</script>